// extracted by mini-css-extract-plugin
module.exports = {"left":"Footer_left__1OLxy space","right":"Footer_right__38qPz space right"};